
function App() {
  return (
    <div>
      <h1>Hello World</h1>
    </div>
  );
}

export default App;
